export { abbrs } from "./abbrs";
export { colors } from "./colors";
export { ranks } from "./ranks";
export { verticals } from "./verticals";
export { verticles } from "./verticles";

export const USE_EMBER_IFRAME = false;
